export const getPlanComparisonText = (comparison: number): string => {
  if (comparison === 0) {
    return 'That’s equal to the';
  }

  if (comparison < 0) {
    return 'Less than';
  }

  return 'More than';
};
